export const slugify = (text: string): string => {
  return text
    .toLocaleLowerCase()
    .replace(/[^a-z0-9 -]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");
};
